import { Base2Presenter } from "core/presenter";
import Moment from "moment";
import { CashRegisterRepository } from "core/repository";

class CashRegisterListPresenter extends Base2Presenter {
  initialState() {
    const urlParams = new URLSearchParams(window.location.hash);
    const startDate = Moment(urlParams.get("inicio"), "DD-MM-YYYY");
    const endDate = Moment(urlParams.get("fim"), "DD-MM-YYYY");
    const typeDate = urlParams.get("tipoData");
    return {
      loading: true,
      results: [],
      pagination: {
        total: 0,
        perPage: 25,
        page: 1
      },
      order: {
        field: "opening_date",
        direction: "DESC"
      },
      filters: {
        startDate: startDate.isValid()
          ? startDate
          : Moment()
              .startOf("day")
              .subtract(7, "days"),
        endDate: endDate.isValid() ? endDate : Moment().endOf("day"),
        dateType: typeDate ? typeDate : "opening_date"
      }
    };
  }

  async onStart() {
    this.load();
  }

  async load() {
    this.enqueue({ loading: true });
    this.renewCancelToken();

    const result = await CashRegisterRepository.getListOnline({
      filters: await this.getFilters(),
      order: [this.viewModel.order],
      pagination: this.viewModel.pagination
    });

    if (result.success) {
      this.enqueue(vm => ({
        results: result.data,
        pagination: {
          ...vm.pagination,
          total: result.total,
          perPage: result.perPage
        }
      }));
    }

    this.enqueue({ loading: false });
  }

  async getFilters() {
    const { startDate, endDate, dateType } = this.viewModel.filters;
    const currentUser = await this.mRuntime.get("currentUser");

    const filters = [
      {
        connector: "AND",
        field: "company_uuid",
        operation: "EQ",
        value: currentUser.company_uuid
      }
    ];

    if (startDate) {
      filters.push({
        connector: "AND",
        field: dateType,
        operation: "GTE",
        value: startDate.toISOString()
      });
    }

    if (endDate) {
      filters.push({
        connector: "AND",
        field: dateType,
        operation: "LTE",
        value: endDate.toISOString()
      });
    }

    return filters;
  }

  onFilterChange(filters) {
    const currentFilters = {};
    Object.assign(currentFilters, this.viewModel.filters, filters);
    for (const key in filters) {
      if (this.viewModel.filters[key] !== filters[key]) {
        this.enqueue(
          vm => ({ filters: { ...vm.filters, ...filters } }),
          () => this.load()
        );
        break;
      }
    }
    const { startDate, endDate, dateType } = currentFilters;
    window.location.hash = `?&inicio=${Moment(startDate).format(
      "DD-MM-YYYY"
    )}&fim=${Moment(endDate).format("DD-MM-YYYY")}&tipoData=${dateType}`;
  }

  onChangeOrder(order) {
    this.enqueue({ order }, () => this.load());
  }

  onChangePage(page) {
    this.enqueue(
      vm => ({ pagination: { ...vm.pagination, page } }),
      () => this.load()
    );
  }
}

export default CashRegisterListPresenter;



// WEBPACK FOOTER //
// ./src/components/app/history/cash-register-reports/list/presenter.js